import { Component, computed, EventEmitter, Input, Output, signal } from '@angular/core'
import { IonicModule } from '@ionic/angular'

import { CommonModule } from '@angular/common'
import countries from './countries'

@Component({
	selector: 'select-country-modal',
	templateUrl: './select-country.modal.html',
	styleUrls: ['./select-country.modal.scss'],
	standalone: true,
	imports: [IonicModule, CommonModule]
})
export class SelectCountryModal {
	@Input() selectedCountry: string | null = null
	@Output() selectedCountryChange = new EventEmitter<string>()
	@Output() countryName = new EventEmitter<string>()
	@Output() close = new EventEmitter<void>()
	// @ViewChild('countryInput', { static: false }) input: IonSearchbar | undefined

	search = signal('')

	onSearchbarInputChange(event: any) {
		this.search.set(event.target.value)
	}

	filteredCountries = computed(() =>
		countries
			.filter(({ name }) => name.toLocaleLowerCase().includes(this.search().toLocaleLowerCase()))
			.sort((a, b) => a.name.localeCompare(b.name, 'sv'))
	)

	selectCountry(country: { name: string; code: string }) {
		this.selectedCountry = country.code
		this.selectedCountryChange.emit(country.code)
		this.countryName.emit(country.name)
	}
}
